module.exports = __webpack_public_path__ + "static/media/Kopie-von-Kopie-von-Kopie-von-IMG_4864.06e66d3f.jpeg";